module.exports = __webpack_public_path__ + "img/e0877df.webp";